import React, { useState } from 'react';
import { shouldMapEnabled } from '../utils';
import VisualSwitch from '../VisualSwitch';
import apptracker from '@src/utils/sensor/apptracker';
import { HIGH_CARDINALITY_BUTTON_CLICK } from '@src/utils/sensor/track';
import Search from '../Search';
import { Button, Tooltip } from 'antd';
import { exploreViewAtom } from '../../atoms';
import { useAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { allDimensionsListSelector } from '@src/store/common/dimensionList/selectors';
import { WidgetActions } from '../styled';
import CardinalityIcon from '@icons/common/cardinality.svg';
import { realTimeModeOnTrendsSelector } from '@src/store/common/selectors';

const DimensionWidgets = ({ dimension, onSearch, searchText, visualType, handleVisualChange }) => {
  const [showHighCardinalityButton, setShowHighCardinalityButton] = useState(true);
  const dimensionList: any[] = useSelector(allDimensionsListSelector);
  const isLiveMode: boolean = useSelector(realTimeModeOnTrendsSelector);
  const [exploreView, setExploreView] = useAtom(exploreViewAtom);
  const dimensionDetails = dimensionList.find((d) => d.groupBy === dimension);

  const onSearchCollapsedAction = (collapsed) => {
    setShowHighCardinalityButton(collapsed);
  };
  return (
    <WidgetActions>
      {shouldMapEnabled(dimension) && (
        <VisualSwitch value={visualType} onChange={handleVisualChange} />
      )}
      <Search onSearch={onSearch} text={searchText} collapsedCallback={onSearchCollapsedAction} />
      {showHighCardinalityButton && dimensionDetails?.isHighCardinality && !isLiveMode && (
        <Tooltip title="High cardinality dimension values are retained only for last 30 days. Some metric values are shown as NA when there are too many unique entries. Click to see sample data.">
          <Button
            style={{ backgroundColor: '#f2f6ff' }}
            size="small"
            onClick={() => {
              apptracker(HIGH_CARDINALITY_BUTTON_CLICK, {
                dimension,
                isHighCardinality: dimensionDetails?.isHighCardinality,
              });
              setExploreView({
                show: true,
                dimension,
                isHighCardinality: dimensionDetails?.isHighCardinality,
              });
            }}
          >
            <span style={{ color: '#0046ff' }}>High Cardinality</span>
            <CardinalityIcon />
          </Button>
        </Tooltip>
      )}
    </WidgetActions>
  );
};

export default DimensionWidgets;
